import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { usePlatform } from '../contexts/PlatformContext';
import { demoAccounts } from '../data/profiles';
export function Login() {
  const {
    authenticate
  } = usePlatform();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return setError('Enter your email and password.');
    setError('');
    setLoading(true);
    setTimeout(() => {
      const account = demoAccounts.find(a => a.email === email.trim().toLowerCase() && a.password === password);
      if (!account) {
        setLoading(false);
        setError('Incorrect email or password.');
        return;
      }
      authenticate();
      navigate('/choose-profile');
    }, 800);
  };
  return <div className="grid min-h-screen w-full bg-[#0f1017] lg:grid-cols-2" data-id="element-175" data-mp="2mfv2h80ubw48">
      <div className="flex flex-col px-6 py-8 md:px-12" data-id="element-176" data-mp="318extmhr0zb4">
        <span className="text-2xl font-semibold tracking-tight" data-id="element-177" data-mp="2wfltgzq6zszk">nawat</span>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12" data-id="element-178" data-mp="3a7jx4v14wwoc">
          <h1 className="text-3xl font-medium tracking-tight" data-id="element-179" data-mp="3a9d82mis6325">Welcome back</h1>
          <p className="mt-2 text-muted-foreground" data-id="element-180" data-mp="3587d0i1ne3pg">Sign in to see your profile, blood results and next pack.</p>

          <form onSubmit={handleSubmit} noValidate className="mt-10 space-y-4" data-id="element-181" data-mp="3k3dj150qu2is">
            <div className="space-y-2" data-id="element-182" data-mp="3f7enmxgzzk8v">
              <label htmlFor="email" className="text-sm font-medium" data-id="element-183" data-mp="1prf7gweyoujq">Email</label>
              <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="h-11 bg-white/5" data-id="element-184" data-mp="1ptjl462nx7x7" />
            </div>
            <div className="space-y-2" data-id="element-185" data-mp="2ahsxf6jxh0wh">
              <div className="flex items-center justify-between" data-id="element-186" data-mp="2aiu6x6lapfc3">
                <label htmlFor="password" className="text-sm font-medium" data-id="element-187" data-mp="2ej4fmr0h2jun">Password</label>
                <button type="button" className="text-xs text-muted-foreground hover:text-foreground" data-id="element-188" data-mp="2jgefl0lhmdwq">Forgot password?</button>
              </div>
              <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="h-11 bg-white/5" data-id="element-189" data-mp="2oe655nyntnxr" />
            </div>
            {error && <p role="alert" className="text-sm text-destructive-foreground" data-id="element-190" data-mp="2xfnt1sib6tx0">{error}</p>}
            <Button type="submit" size="lg" disabled={loading} className="h-11 w-full bg-[#9b8cf0] text-[#0f1017] hover:bg-[#b0a4f5]" data-id="element-191" data-mp="3298gwrq6u7ih">
              {loading ? <Loader2 className="size-4 animate-spin" data-id="element-192" data-mp="3c63gldy76dyc" /> : <>Sign in <ArrowRight className="size-4" data-id="element-193" data-mp="3c7o9z08rzqum" /></>}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-muted-foreground" data-id="element-194" data-mp="3h6988u4gw0gf">
            New to Nawat? <button className="text-foreground underline-offset-4 hover:underline" data-id="element-195" data-mp="15i4exeywil7f">Book a blood test</button>
          </p>
        </div>
        <p className="text-xs text-muted-foreground" data-id="element-196" data-mp="10hge61kveq00">
          Concept prototype · Data shown is illustrative
        </p>
      </div>

      <div className="relative hidden overflow-hidden lg:block" data-id="element-197" data-mp="qkllhzba3jtn">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/7fd89192-c369-4be9-bec0-8e3aa03a4871.jpg" alt="" className="absolute inset-0 size-full object-cover" data-id="element-198" data-mp="qmept7yf5ryh" />
        <div className="absolute inset-0 bg-[#0f1017]/40" data-id="element-199" data-mp="1jbloq81scjk9" />
        <div className="absolute bottom-10 left-10 right-10 rounded-2xl border border-white/10 bg-[#0f1017]/80 p-6 backdrop-blur" data-id="element-200" data-mp="1eh80cpljjcp3">
          <p className="text-lg leading-snug" data-id="element-201" data-mp="19hd92kxusl3i">100 biomarkers. One doctor-verified daily pack, delivered every month.</p>
          <p className="mt-3 font-mono text-xs uppercase tracking-widest text-[#c4baff]" data-id="element-202" data-mp="2283pfeym3tsn">Pregnancy · Wellbeing</p>
        </div>
      </div>
    </div>;
}